/**
 * @description: fetch most recently tracked items from server.
 * @requires {Object} configService
 * @requires {Object} parcelsService
 * @requires {Object} applicationModel
 * @requires {Object} numberService
 * @requires {Object} $location
 * @requires {Object} $cookies
 * @requires {Function} $timeout
 * @requires {Object} $window
 */
function recentlyTrackedController(
  configService,
  parcelsService,
  numberService,
  applicationModel,
  $location,
  $cookies,
  $timeout,
  $window) {

  const vm = this;

  function handleResponseError(rejection) {

    // No error message from API, use CMS defined.
    if (typeof rejection !== 'object' || !Array.isArray(rejection)) {

      vm.rtiError = configService.messages.recently_tracked.error;

    } else {

      vm.rtiListError = rejection;

    }

  }

  function init() {

    // Checks the parcels_jwt cookie was found and is valid.
    if (parcelsService.isValidCookie()) {

      // Set authToken as the parcels_jwt cookie was found and is valid.
      applicationModel.authToken = $cookies.get('parcels_jwt');

      const JWT = parcelsService.decodeJWT(applicationModel.authToken);
      const guid = (parcelsService.isSet(JWT, 'sub') !== '') ? parcelsService.isSet(JWT, 'sub') : 0;

      // API call as we have a valid auth token.
      parcelsService.getRtiResults(
        guid,
        configService.api.app_id,
        configService.api.recently_tracked_max_items
      ).then((response) => {

        vm.recentlyTrackedItems = parcelsService.isSet(response.data, 'mailPieces');

      }, (rejection) => {

        handleResponseError(rejection);

      });

    } else {

      // Resetting to default values as parcels_jwt cookie wasn't found or it is invalid.
      vm.loggedIn = false;
      applicationModel.authToken = null;
      handleResponseError('');

    }

  }

  /**
   * Reset variables.
   */
  function reset() {

    vm.recentlyTrackedItems.length = 0;
    delete vm.rtiListError;
    delete vm.rtiError;

  }

  function refresh() {

    // Reset variables to avoid wrong old data.
    reset();
    init();

  }

  function followLink(link) {

    $location.url(`/tracking-results/${link}`);

  }

  function isResultsPage() {

    return (window.location.hash.indexOf('tracking-results') > -1);

  }

  function trackingNumber() {

    return applicationModel.sanitizedNumber;

  }

  function renderTrackingNumber(code) {

    return numberService.filterNumber(code);

  }

  vm.recentlyTrackedItems = [];
  vm.loggedIn = parcelsService.isValidCookie;
  vm.details = configService.messages.recently_tracked.details_button;
  vm.refresh = configService.messages.recently_tracked.refresh_button;
  vm.redelivery = configService.messages.recently_tracked.redelivery_button;
  vm.saveItems = configService.messages.recently_tracked.save_items;
  vm.login = configService.messages.recently_tracked.login;
  vm.login_default = configService.messages.recently_tracked.login_default;
  vm.rtiLinkText = configService.messages.recently_tracked.link_text;
  vm.rtiLink = configService.links.rti_full_page;
  vm.manualRefresh = refresh;
  vm.followLink = followLink;
  vm.init = init;
  vm.configService = configService;
  vm.isResultsPage = isResultsPage;
  vm.trackingNumber = trackingNumber;
  vm.renderTrackingNumber = renderTrackingNumber;
  vm.markdownToHTML = parcelsService.markdownToHTML;

  if (vm.loggedIn) init();

  // Use timeout 0 here to wait until the DOM is fully loaded.
  $timeout(() => {

    // Make triggerRTIWidgetReload available in the window object to share with Drupal.
    $window.triggerRTIWidgetReload = refresh;

  });

}

export default recentlyTrackedController;



// WEBPACK FOOTER //
// ./src/components/recentlytracked/recently-tracked.controller.js